import React, { useEffect, useCallback } from 'react';
import { useTranslation } from "../../context/TranslationContext";
import { useWebSocket } from '../../context/WebSocketContext';
import { useNavigate } from "react-router-dom";
import { ConnectionEventEmitter } from '../../utils/ConnectionEventEmitter';
import List from "../../components/List";
import log from "loglevel";

import '../../styles/Host.css'; 

function HostDishes() {
  const { t, language } = useTranslation();
  const { sendMessage, isConnected } = useWebSocket();
  const navigate = useNavigate();

  const list = {
    "elements": [
      {
        "id": 1,
        "name": {
          "pl": "Paella Valenciana",
          "en": "Valencian Paella",
          "de": "Valencianische Paella"
        },
        "slogan": {
          "pl": "Tradycyjne danie z ryżem, szafranem i owocami morza!",
          "en": "Traditional rice dish with saffron and seafood!",
          "de": "Traditionelles Reisgericht mit Safran und Meeresfrüchten!"
        },
        "icon": "https://example.com/icons/paella_icon.png"
      },
      {
        "id": 2,
        "name": {
          "pl": "Gazpacho",
          "en": "Gazpacho",
          "de": "Gazpacho"
        },
        "slogan": {
          "pl": "Chłodnik pomidorowy idealny na upalne dni!",
          "en": "Cold tomato soup, perfect for hot days!",
          "de": "Kalte Tomatensuppe, perfekt für heiße Tage!"
        },
        "icon": "https://example.com/icons/gazpacho_icon.png"
      },
      {
        "id": 3,
        "name": {
          "pl": "Tortilla Española",
          "en": "Spanish Omelette",
          "de": "Spanisches Omelett"
        },
        "slogan": {
          "pl": "Klasyczny omlet ziemniaczany!",
          "en": "Classic potato omelette!",
          "de": "Klassisches Kartoffel-Omelett!"
        },
        "icon": "https://example.com/icons/tortilla_icon.png"
      },
      {
        "id": 4,
        "name": {
          "pl": "Churros con Chocolate",
          "en": "Churros with Chocolate",
          "de": "Churros mit Schokolade"
        },
        "slogan": {
          "pl": "Słodkie, chrupiące ciastka z czekoladowym sosem!",
          "en": "Sweet, crispy pastries with chocolate sauce!",
          "de": "Süße, knusprige Gebäckstücke mit Schokoladensoße!"
        },
        "icon": "https://example.com/icons/churros_icon.png"
      },
      {
        "id": 5,
        "name": {
          "pl": "Pulpo a la Gallega",
          "en": "Galician-style Octopus",
          "de": "Galicischer Oktopus"
        },
        "slogan": {
          "pl": "Delikatna ośmiornica z papryką i oliwą!",
          "en": "Tender octopus with paprika and olive oil!",
          "de": "Zarter Oktopus mit Paprika und Olivenöl!"
        },
        "icon": "https://example.com/icons/pulpo_icon.png"
      }
    ]
  }

  const connectionOpened = useCallback(() => {
    log.debug('Dishes connectionOpened');
  }, []);

  const connectionClosed = useCallback(() => {
    log.debug('Dishes connectionClosed');
  }, []);

  const connectionReceived = useCallback((receivedMessage) => {
    if(receivedMessage) {
      log.debug('Dishes received message:', receivedMessage);
    }
  }, []);

  const handleBack = () => {
    navigate('/host'); 
  };

  const handleAdd = () => {
    console.log("Add button clicked");
  };

  const getLabel = (item) => {
    return item.name[language];
  };

  const getDescription = (item) => {
    return item.slogan[language];
  };

  useEffect(() => {    
    ConnectionEventEmitter.on('opened', connectionOpened);
    ConnectionEventEmitter.on('closed', connectionClosed);
    ConnectionEventEmitter.on('received', connectionReceived);
    return () => { 
      ConnectionEventEmitter.off('opened', connectionOpened);
      ConnectionEventEmitter.off('closed', connectionClosed);
      ConnectionEventEmitter.off('received', connectionReceived);
    }
  }, []);

  return (
    <List list={list} id="dishes" title={t.host.Dishes} onBack={handleBack} onAdd={handleAdd} getLabel={getLabel} getDescription={getDescription}></List>
  );
}

export default HostDishes;